import { SET_RESTAURANT_USER, LOADING_RESTAURANT, ERROR_RESTAURANT } from './../actions/setRestaurantById';
import { SET_PROFILE_RESTAURANT_USER, SAVING_RESTAURANT } from './../actions/setProfileDataToRestaurant';
import { SET_DEFAULT_TIMETABLE_RESTAURANT_USER } from '../actions/setDefaultTimetableToRestaurant';
import { SET_RESERVE_CONFIGURATIONS_RESTAURANT_USER, SAVED_RESTAURANT } from '../actions/setReserveConfigurationsToRestaurant';
import { SET_PROMOTIONS_RESTAURANT_USER } from '../actions/setPromotionsToRestaurant';
import { SET_IMAGES_RESTAURANT_USER } from '../actions/setImagesDataToRestaurant';
import { SET_PROMOTIONS_PER_DAY_RESTAURANT_USER } from '../actions/setPromotionsPerDayToRestaurant';

export const restaurant = (state = {}, action) => {
    switch(action.type) {
        case SET_RESTAURANT_USER: {
            return action.payload;
        }
        case SET_PROFILE_RESTAURANT_USER: {
            const { name, phone, facebook, instagram, website, country, province, city, neighborhood, postalCodeV2, street, lat, lng, hitos, styles, types, services, accessPeopleWithDisabilities } = action.payload;
            return { ...state, restaurant: { ...restaurant, name, phone, facebook, instagram, website, address: { country, province, city, neighborhood, postalCodeV2, street, hitos, }, l: [lat, lng], styles, types, services, accessPeopleWithDisabilities } };
        }
        case SET_IMAGES_RESTAURANT_USER: {
            const { logo, media } = action.payload;
            return { ...state, restaurant: { ...restaurant, logo, media } };
        }
        case SET_DEFAULT_TIMETABLE_RESTAURANT_USER: {
            const { defaultHours } = action.payload;
            return { ...state, restaurant: { ...restaurant, timetable: { default: defaultHours }}};
        }
        case SET_RESERVE_CONFIGURATIONS_RESTAURANT_USER: {
            const { totalCapacity, reservationCapacity, minPlacesPerReservation, maxPlacesPerReservation, averageReservationTime, minimumPreviousReservationHours, maximumPreviousReservationDays, reservePreviousCancellationTime } = action.payload;
            return { ...state, restaurant: { ...restaurant, totalCapacity, reservationCapacity, minPlacesPerReservation, maxPlacesPerReservation, averageReservationTime, minimumPreviousReservationHours, maximumPreviousReservationDays, reservePreviousCancellationTime } };
        }
        case SET_PROMOTIONS_RESTAURANT_USER: {
            const { promotions } = action.payload;
            return { ...state, restaurant: { ...restaurant, promotions }};
        }
        case SET_PROMOTIONS_PER_DAY_RESTAURANT_USER: {
            const { promotionsPerDay } = action.payload;
            return { ...state, restaurant: { ...restaurant, promotionsPerDay }};
        }
        default:
            return state;
    }
}

export const isLoadingRestaurant = (state = {}, action) => {
    switch(action.type) {
        case LOADING_RESTAURANT: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const isSavingRestaurant = (state = {}, action) => {
    switch(action.type) {
        case SAVING_RESTAURANT: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const errorRestaurant = (state = {}, action) => {
    switch(action.type) {
        case ERROR_RESTAURANT: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const isSavedRestaurant = (state = {}, action) => {
    switch(action.type) {
        case SAVED_RESTAURANT: {
            return action.payload;
        }
        default:
            return state;
    }
}